<template>
  <section class="quote-plan-list">
    <div
      v-for="(item, index) in allQuoteList"
      :key="'key' + index"
      class="plan-container">
      <template v-if="false">
        <div class="left">
          <span
            v-if="productId == 11"
            class="span-checkbox">{{ item.plan_info.trm_of_cvr_nm }}</span>
          <span class="logo">
            <img
              :src="item.plan_info? item.plan_info.company_logo: ''"
              alt="logo" />
          </span>
        </div>
        <div class="middle">
          <span class="title">{{ item.plan_info.plan }}</span>
          <!-- <span class="title">{{ getOptionName('classOptions', classId) }} Insurance {{ getOptionName('coverTypeOptions', item.trm_of_cvr) }} Plan</span> -->
          <div class="abs-top-right">
            <v-button
              type="info"
              plain
              @click="handlerPlanInfo(index)">More Info</v-button>
          </div>
          <company-quote-plan-info
            :isRenew="type == 20"
            :item="item"
            :classId="classId" />
        <!-- <housemaid-company-quote-info
          v-if="productId == 12"
          :item="item"
          :classId="classId" />
        <company-quote-info
          v-else-if="[13, 16].includes(productId)"
          :item="item"
          :classId="classId" />
        <travel-company-quote-info
          v-else-if="[14, 17].includes(productId)"
          :item="item"
          :classId="classId" />
        <decoration-company-quote-info
          v-else-if="productId == 15"
          :item="item"
          :classId="classId" />
        <motor-company-quote-info
          v-else
          :classId="classId"
          :item="item" /> -->
        </div>
        <div
          class="right "
          :class="item.plan_info.is_sponsor===1?'top':''"
        >
          <span
            v-if="item.plan_info.top===1"
            class="span-top">Top</span>
          <span
            v-if="item.plan_info.is_sponsor===1"
            class="span_sponsor">Sponsor </span>
          <span  class="flex flex-aglin">
            <span
              :style="{ fontSize: cssFontSize(item.plan_info.payable, 130, 24) }"
              class="amount">{{ item.plan_info.payable | formatMoney(2, false) }}</span>
            <font-awesome-icon
              class="icon"
              icon="info-circle"
              @click="handleShowPremium(index)"></font-awesome-icon>
          </span>
          <span
            v-if="item.plan_info.payable_original!=item.plan_info.payable"
            class="flex">
            <span class="orgin_price">
              {{item.plan_info.payable_original}}
            </span>
            <span
              v-if="item.plan_info.discount_str"
              class="percent">({{item.plan_info.discount_str}})</span>
          </span>
          <span class="unit">HK$ per year</span>

          <v-button
            v-if="type == 20"
            class="button"
            type="success"
            @click="handlerSelect(item)">Select</v-button>

          <v-button
            v-else
            class="button"
            type="primary"
            @click="handlerBuyPolicy(index)">Buy Policy</v-button>

        </div>
      </template>
      <div class="tags">
        <span
          v-if="item.plan_info.is_sponsor===1"
          class="tag sponsor">{{item.plan_info.sponsor}}</span>
        <span
          v-for="(tag, i) in item.plan_info.tags"
          :key="i"
          class="tag">
          {{tag | changeTag}}
        </span>
        <span
          v-if="productId == 11"
          class="tag">{{ item.plan_info.trm_of_cvr_nm }}</span>
      </div>
      <div class="info">
        <div class="icon item">
          <span class="logo">
            <img
              :src="item.plan_info? item.plan_info.company_logo: ''"
              alt="logo" />
          </span>
        </div>
        <div class="plan item">
          <span>{{ item.plan_info.plan }}</span>
        </div>
        <div class="price item">
          <span class="flex top">
            <span
              :style="{ fontSize: cssFontSize(item.plan_info.payable, 130, 24) }"
              class="amount">{{ item.plan_info.payable | formatMoney(2, false) }}</span>
            <font-awesome-icon
              class="icon pointer"
              icon="info-circle"
              @click="handleShowPremium(index)"></font-awesome-icon>
          </span>
          <span
            v-if="item.plan_info.payable_original!=item.plan_info.payable"
            class="flex-column flex-align-center">
            <span class="orgin_price">
              {{item.plan_info.payable_original}}
            </span>
            <span
              v-if="item.plan_info.discount_arr.length"
              class="percent">
              <span
                v-for="(item_discount, i_discount) in item.plan_info.discount_arr"
                :key="i_discount">{{item_discount.discount_str}}</span>
            </span>
          </span>
        </div>

        <div class="btn item">
          <v-button
            v-if="type == 20"
            class="button success"
            @click="handlerSelect(item)">Select</v-button>

          <v-button
            v-else
            class="button success"
            @click="handlerBuyPolicy(index)">Buy Policy</v-button>
        </div>
      </div>

      <div class="detail flex flex-algin-end">
        <div class="left_content">
          <span
            v-if="item.plan_info.agency_language"
            class="fs-12 color-gray2 block mg-b-15 mg-l-20">{{item.plan_info.agency_language}}</span>
          <ul v-if="list_b.length">
            <li
              v-for="(list, list_index) in list_b[index].data"
              :key="list_index">
              <span>{{list.item}}</span>
              <span>{{list.premium}}</span>
            </li>
          </ul>
        </div>
        <div class="right-content">
          <div class="">
            <span
              v-if="[14,12,17].includes(productId)&&item.plan_info.sponsor_pct>0"
              class="">
              <span class="flex flex-end">
                <span class="save-box">
                  saving {{item.plan_info.sponsor_pct}}%
                </span>
              </span>
              <span class="flex flex-end mg-b-10">
                <span
                  class="flex-column flex-end ">
                  <span class="fs-14 text-right fw-400 color-gray60">Official</span>
                  <span class="color-gray60 fw-600">{{ item.plan_info.payable_original | formatMoney(2, false,true) }}</span>
                </span>
                <span class="line"></span>
                <span
                  class="flex-column flex-end text-center">
                  <span class="fs-14 fw-400 color-gray60">Other Platform</span>
                  <span class="color-orange fw-600">{{ item.plan_info.other_platform_prm | formatMoney(2, false,true) }}</span>
                </span>
              </span>
            </span>
            <div class="flex-align-center">
              <div class="flex-inline">
                <div>
                  <popover @selectLang="getLang">
                    <v-button
                      gray
                      icon="sms"
                      @click="handleShare(1,item.plan_info)">SMS
                    </v-button>
                  </popover>
                </div>
                <div>
                  <popover @selectLang="getLang">
                    <v-button
                      gray
                      icon="envelope"
                      @click="handleShare(3,item.plan_info)">Email
                    </v-button>
                  </popover>
                </div>
              </div>
              <div class="flex">
                <span
                  v-if="!planInfoList[index].showMore"
                  class="pointer"
                  @click="showMoreInfo(index)">
                  More Detail
                  <font-awesome-icon
                    icon="angle-down"></font-awesome-icon>
                </span>
                <span
                  v-else
                  class="pointer"
                  @click="showMoreInfo(index)">
                  Less Detail
                  <font-awesome-icon
                    icon="angle-up"></font-awesome-icon>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div
        v-if="planInfoList[index].showMore"
        class="more-info">
        <div class="download">
          <div>
            <span>Download</span>
            <span
              v-for="(item, policy_index) in policyDetail[index].items"
              :key="policy_index"
              class="item pointer"
              @click="openReferenceQuote(item, index)">{{ item.file_name }}</span>
          </div>
          <span
            class="item pointer"
            @click="handleToInsurer(planInfoList[index].plan_info)">More Plan Info</span>
        </div>

        <div class="line"></div>

        <all-company-quote-plan-info
          :is-sme-product="isSMEProduct"
          :planInfo="planInfoList[index]" />
      </div>
    </div>
    <plan-dialog
      ref="plan-dialog"
      :planInfo="planInfoData"
      :isRenew="isRenew"
      :detail_b="detail_b"
      :index="activeIndex"
      :haveReferenceQuote="haveReferenceQuote"
      @get-reference-quote="getReferenceQuote" />
    <show-premium-data
      ref="premium-dialog"
      :showPremiumData="showPremiumData">
    </show-premium-data>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import PlanDialog from '../dialogs/plan-dialog'
import CompanyQuotePlanInfo from '../modules/components/company-quote-info'
import ShowPremiumData from './premium-data'
import {downloadFileName} from '@/utils/download'
import AllCompanyQuotePlanInfo from '../modules/components/company-quote-plan-info-new'
import popover from '@/views/quoting/components/popover'

export default {
  name: 'QuotePlanList',
  components: {
    PlanDialog,
    CompanyQuotePlanInfo,
    ShowPremiumData,
    AllCompanyQuotePlanInfo,
    popover
    // MotorCompanyQuoteInfo,
    // HousemaidCompanyQuoteInfo,
    // CompanyQuoteInfo,
    // TravelCompanyQuoteInfo,
    // DecorationCompanyQuoteInfo
  },
  filters:{
    changeTag(tag){
      let res = ''
      switch(tag){
        case 'cheapest':
          res = 'Cheapest'
          break
        case 'best_coverage':
          res = 'Best Coverage'
          break
        case 'recommended':
          res = 'Recommended'
          break
      }
      return res
    }
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    allQuoteList: {
      type: Array,
      default: () => ([])
    },
    classId: {
      type: [String, Number],
      default: ''
    },
    quoteDetailData: {
      type: Array,
      default: () => ([])
    },
    shortlist: {
      type: Array,
      default: () => ([])
    },
    haveReferenceQuote: {
      type: Boolean,
      default: false
    },
    type: {
      type: [Number,String],
      default: 0
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    detail_b:{
      type: Array,
      default: () => []
    },
    list_b:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      planInfoData: {},
      showPremiumData: {},
      activeIndex: 0,
      planInfoList: [],
      contactType:1,
      shareLink:''
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    policyDetail() {
      let res = this.planInfoList.reduce((result, item) => {
        result.push(item.policy_detail)
        return result
      }, [])
      return res
    },
    isSMEProduct(){
      let {product_id} = this.$route.query
      return product_id>80
    },
  },
  watch:{
    quoteDetailData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          this.planInfoList=[]
        }
        Object.keys(val).forEach(key => {
          let obj = {
            showMore: false,
            ...val[key]
          }
          this.planInfoList.push(obj)
        })
      }
    }
  },
  methods: {
    getLang(lang){
      let langType = lang == 'en'? 1 : 0
      // this.network().getQuoteShare()
      this.$emit('share-lang',langType)
    },
    handleShare(type,item){
      let {plan_id,company_id} = item||{}
      this.$emit('share-one-plan',type,{plan_id,company_id})
    },
    handleShowPremium(index){
      this.showPremiumData = this.shortlist[index]
      this.$refs['premium-dialog'].changeDialog()
    },
    handlerPlanInfo(index) {
      this.planInfoData = {
        class_id: this.classId,
        ...this.quoteDetailData[index]
      }
      this.activeIndex = index
      this.$refs['plan-dialog'].changeDialog()
    },
    handlerBuyPolicy(index) {
      this.$emit('buy-policy', index)
    },
    handlerSelect(item){
      this.$emit('select-policy', item.plan_info)
    },
    getReferenceQuote(url) {
      this.$emit('get-reference-quote', this.activeIndex, url)
    },
    showMoreInfo(index){
      this.planInfoList[index].showMore = !this.planInfoList[index].showMore
    },
    openReferenceQuote(item, index) {
      let quo_id = null
      if(this.detail_b.length && this.detail_b[index] && this.detail_b[index].plan_info){
        quo_id = this.detail_b[index].plan_info.quo_id || null
      }
      let {file_type,file_url, file_name} = item||{}

      // file_type = reference的时候需要弹出下载框下载
      if(file_type=='reference' && (!this.isRenew || !quo_id)){
        // 请求对应的接口
        this.$emit('get-reference-quote', index, file_url)
      }else if(file_type=='reference'){
        // 将文件地址转换为文件流再下载
        downloadFileName(file_url, `${file_name}.pdf`)
      }else{
        // 其他的直接打开文件
        this.openFile(file_url)
      }
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    handleToInsurer(item){
      const {class_id, company_id, plan_id} = item
      this.$router.push({
        name: 'insurerAccountsPlanDetail',
        query:{
          company_id,
          class_id,
          plan_id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-plan-list {
  .plan-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .left {
      width: 130px;
      text-align: center;
      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        width: 120px;
        height: 64px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: relative;
      margin: -15px -15px -15px 0;
      padding-left: 16px;
      width: 140px;
      background: #f4f4f5;
      &.top{
        background: #ECF5FF;
      }
      .span-top {
        position: absolute;
        top: 16px;
        left: 16px;
        display: block;
        padding: 9px 10px;
        border: 1px solid #faecd8;
        border-radius: 4px;
        background: #fdf6ec;
        font-size: 12px;
        color: #e6a23c;
      }
      .span_sponsor{
        margin: 16px 0;
        height: 32px;
        width: 68px;
        font-size: 12px;
        color: #e6a23c;
        border: 1px solid #FAECD8;
        border-radius: 4px;
        background-color: #FDF6EC;
        justify-content: center;
        display: flex;
        align-items: center;
      }
      .orgin_price{
        text-decoration: line-through;
        color: #616266;
        font-family: "Helvetica Neue";
        font-size: 14px;
        margin: 4px 0;
      }
      .percent{
        color: #616266;
        font-family: "Helvetica Neue";
        font-size: 14px;
        margin: 4px 0;
        margin-left: 8px;
      }
      .amount {
        display: block;
        font-size: 24px!important;
        font-weight: bold;
        color: #409eff;
        font-family: "Helvetica Neue";
        word-break: break-word;
      }
      .unit {
        color: #616266;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .el-button {
        //position: absolute;
        //bottom: 15px;
        //left: 15px;

        margin: 26px  15px 16px 0px;
      }
    }
    .middle {
      flex: 1;
      position: relative;
      padding-right: 15px;
      .abs-top-right {
        right: 15px;
      }
      .title {
        padding-right: 90px;
        font-size: 20px;
        color: #616266;
        font-weight: bold;
      }

    }
    .info{
      display: flex;
      margin: 10px 0 15px 0;
      .icon {
        width: 75px;
        height: 40px;
        text-align: center;
        .logo {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .plan{
        flex: 1;
        display: flex;
        align-items: center;
        span{
          font-weight: 600;
          font-size: 14px;
          color: #24292E;
        }
      }
      .price{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .top{
          height: 24px;
          line-height: 24px;
          align-items: center;
          .amount {
            font-size: 24px!important;
            font-weight: 600;
            color: #24292E;
            word-break: break-word;
          }
          .icon{
            width: 14px;
            height: 14px;
            font-size: 14px;
            margin-left: 5px;
            color: #6A737D;
          }
        }
        .orgin_price{
          text-decoration: line-through;
          color: #616266;
          font-size: 14px;
          margin: 4px 0;
        }
        .percent{
          color: #616266;
          font-size: 14px;
          margin: 4px 0;
        }
      }
      .btn{
        .button{
          width: 120px;
          height: 40px;
          box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
          border-radius: 6px;
          font-size: 14px;
          &.success{
            background: #2EA44F;
            color: #FFFFFF;
            border: 1px solid rgba(27, 31, 35, 0.15);
          }
        }
      }
      .item + .item{
        margin-left: 15px;
      }
    }
    .tags{
      .tag{
        padding: 1px 8px;
        height: 20px;
        background: #FFFFFF;
        border: 1px solid #6A737D;
        border-radius: 100px;
        color: #24292E;
        font-weight: 600;
        font-size: 12px;
        &.sponsor{
          border: 1px solid #6F42C1;
          color: #6F42C1;
        }
        & + .tag{
          margin-left: 10px;
        }
      }
    }
    .detail{
      justify-content: space-between;
      ul{
        padding-left: 40px;
        li{
          font-weight: 600;
          font-size: 12px;
          color: #6A737D;
          height: 18px;
          span + span{
            margin-left: 5px;
          }
          & + li{
            margin-top: 5px;
          }
        }
      }
      .right-content{
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        color: #0366D6;
        font-size: 14px;
        font-weight: 400;
        .flex-inline{
          display: flex;
          margin-right: 20px;
          div{
            &:first-child{
              .el-button{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
              }
            }
            &:last-child{
              .el-button{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
              }
            }
          }
        }
      }
    }
    .more-info{
      padding: 15px;
      background: #FAFBFC;
      margin-top: 15px;
      .download{
        display: flex;
        justify-content: space-between;
        span{
          font-weight: 600;
          font-size: 14px;
          &.item{
            color: #0366D6;
            font-weight: 400;
          }
          & + span{
            margin-left: 20px;
          }
          &:first-child{
            color: #24292E;
          }
        }
      }
      .line{
        border-top: 1px solid #D1D5DA;
        margin: 15px 0;
      }
    }
  }
  .flex-aglin{
    align-items: center;
    .icon{
      font-size: 14px;
      line-height: 16px;
      color: #6A737D;
      margin-left: 5px;
      cursor: pointer;
    }
  }
}
.flex-end{
  //align-items: flex-end;
  justify-content: flex-end;
}
.flex-algin-end{
  align-items: flex-end;
}
.line{
  border: 1px solid #E6EAEF;
  margin: 0px 8px;
}
.save-box{
  border-radius: 6px 0px 6px 6px;
  border: 1px solid #007DF0;
background: #00A3FF;
  color:#FFF;
  text-align: center;
  font-family: "Red Hat Text";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 3px 6px;
}
</style>
